import React from 'react'
import { Image, Transformation } from 'cloudinary-react'
import { useStyles } from './TechlinkJobShowBannerDesktop_style'
import { Box, Chip, Typography, Container } from '@material-ui/core'
import CollectionHandler from 'assets/CollectionHandler.js'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import TechlinkApplyButton from '../../../TechlinkApplyButton/TechlinkApplyButton'
import useJobIconColor from 'hooks/useJobIconColor'

const TechlinkJobShowBannerDesktop = (props) => {
    const { user, job, unavailable, companyTechlinkUrl } = props
    const classes = useStyles()

    return (
        <Container className={classes.bannerContainer} maxWidth='lg' disableGutters>
            <Box className={classes.containerStyle}>
                <Box className={classes.leftContainer}>
                    {job.company_logo_cloudinary_key &&
                        <Box className={classes.companyLogoContainer}>
                            <RouteMapLink
                                page={companyTechlinkUrl}
                                className={classes.logoBox}
                            >
                                <Image
                                    className={classes.logo}
                                    cloudName="studentbe"
                                    publicId={job.company_logo_cloudinary_key}
                                    alt={job.company_name}
                                >
                                    <Transformation flags="progressive" fetchFormat="auto" width="150" quality="auto:good" crop="scale" />
                                </Image>
                            </RouteMapLink>
                        </Box>}
                    <Box className={classes.textContainer}>
                        <RouteMapLink
                            page={companyTechlinkUrl}
                        >
                            <Typography component='body1' className={classes.companyName}>
                                {job.company_name?.toUpperCase()}
                            </Typography>
                        </RouteMapLink>
                        <Typography component='h1' className={classes.jobTitle}>
                            {job.title}
                        </Typography>
                        <Box className={classes.tagsContainer}>
                            <Chip
                                style={{ backgroundColor: useJobIconColor(job.type) }}
                                classes={{ root: classes.tag, label: classes.tagLabel }}
                                label={CollectionHandler.Translate('jobTypeCollection', job.type)}
                            />
                            {job.company_size &&
                                <Chip
                                    classes={{ root: classes.tag, label: classes.tagLabel }}
                                    label={CollectionHandler.Translate('companySizeCollection', job.company_size)}
                                />
                            }
                            {job.sector &&
                                <Chip
                                    classes={{ root: classes.tag, label: classes.tagLabel }}
                                    label={CollectionHandler.Translate('sectorCollection', job.sector)}
                                />
                            }
                        </Box>
                    </Box>
                </Box>
                {!unavailable && <Box className={classes.rightContainer}>
                    <Box className={classes.buttonsContainer}>
                        <TechlinkApplyButton
                            containerClass={classes.applyButtonContainer}
                            job={job}
                            user={user}
                            unavailable={unavailable}
                        />
                    </Box>
                </Box>}
            </Box>
        </Container>
    )
}

export default TechlinkJobShowBannerDesktop
